var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import { make } from 'vuex-pathify';
import Notify from 'quasar/src/plugins/Notify.js';;
import rpc from '../../api/rpc';
import fullScreenLoading from 'src/utils/fullScreenLoading';
import fetchRecords from 'src/utils/entityOperations/fetchRecords';
import actingUser from '../actingUser';
import { getActingUser } from 'src/utils/actingUser';
import Account from 'src/platform/pages/Account.vue';
import setRecords from 'src/utils/entityOperations/setRecords';
import getSessionContext from 'src/utils/context/getSessionContext';
const state = {
    userObj: null,
    jwt: null,
    roles: null,
    controlledActions: null,
    availableTenantsAndApps: null,
    availableOrgs: null,
    currentAppObject: null,
    currentTenantObject: null,
    currentOrgObject: null,
    tenantAppOrgSelectorVisible: false
};
const mutations = Object.assign(Object.assign({}, make.mutations(state)), { SET_AUTHORIZED_USER(state, params) {
        var _a, _b, _c, _d;
        state.userObj = params.userObj;
        state.jwt = params.jwt;
        if (params.userIsSessionScoped) {
            sessionStorage.setItem('authorized_user_id', String((_a = params.userObj) === null || _a === void 0 ? void 0 : _a.id));
            sessionStorage.setItem('acting_user_id', String((_b = params.userObj) === null || _b === void 0 ? void 0 : _b.id));
            sessionStorage.setItem('AUTH_TOKEN', params.jwt);
        }
        else {
            localStorage.setItem('authorized_user_id', String((_c = params.userObj) === null || _c === void 0 ? void 0 : _c.id));
            localStorage.setItem('acting_user_id', String((_d = params.userObj) === null || _d === void 0 ? void 0 : _d.id));
            localStorage.setItem('AUTH_TOKEN', params.jwt);
        }
    } });
const getters = {
    moreThanOneTenantOrAppOrOrgAvailable: (state) => {
        var _a, _b, _c, _d, _e;
        return ((_a = state.availableOrgs) === null || _a === void 0 ? void 0 : _a.length) > 1 ||
            ((_c = (_b = state.availableTenantsAndApps) === null || _b === void 0 ? void 0 : _b.available_tenants) === null || _c === void 0 ? void 0 : _c.length) > 1 ||
            ((_e = (_d = state.availableTenantsAndApps) === null || _d === void 0 ? void 0 : _d.available_apps) === null || _e === void 0 ? void 0 : _e.length) > 1;
    },
    getUserId: (state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.userObj) === null || _a === void 0 ? void 0 : _a.id; }
};
const actions = {
    unsetRolesAndControlledActions({ dispatch, commit }) {
        commit('SET_ROLES', undefined);
        commit('SET_CONTROLLED_ACTIONS', undefined);
        dispatch('actingUser/setRoles', undefined, { root: true });
        dispatch('actingUser/setControlledActions', undefined, { root: true });
    },
    initializeAppContext({ dispatch, commit, state }) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function* () {
            const currentContext = getSessionContext();
            const authorizedUserId = Number(localStorage.getItem('authorized_user_id'));
            const lastSelectedTenantId = currentContext.tenant_id;
            const lastSelectedAppId = currentContext.app_id;
            const lastSelectedOrgId = currentContext.org_id;
            if (!authorizedUserId) {
                dispatch('doLogout');
                return false;
            }
            const response = yield rpc('users.available_tenant_app_combinations_for_user_fetch');
            if (!response)
                return false;
            commit('SET_AVAILABLE_TENANTS_AND_APPS', response);
            setRecords('apps.apps', response.available_apps);
            const appsLen = (_a = response.available_apps) === null || _a === void 0 ? void 0 : _a.length;
            const tenantsLen = (_b = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _b === void 0 ? void 0 : _b.length;
            if (lastSelectedAppId && lastSelectedTenantId) {
                const tenant = (_c = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _c === void 0 ? void 0 : _c.find((r) => { var _a; return ((_a = r.org) === null || _a === void 0 ? void 0 : _a.id) === lastSelectedTenantId; });
                const app = tenant === null || tenant === void 0 ? void 0 : tenant.apps.find((a) => a.id === lastSelectedAppId);
                commit('SET_CURRENT_TENANT_OBJECT', tenant === null || tenant === void 0 ? void 0 : tenant.org);
                localStorage.setItem('lastSelectedTenantId', String((_d = tenant === null || tenant === void 0 ? void 0 : tenant.org) === null || _d === void 0 ? void 0 : _d.id));
                commit('SET_CURRENT_APP_OBJECT', app);
                localStorage.setItem('lastSelectedAppId', String(app === null || app === void 0 ? void 0 : app.id));
                // if no Tenant and App were found in the localStorage, then pick the first available Tenant-App combination
            }
            else if (appsLen === 1 && tenantsLen === 1) { // when we have only one combination of Tenant-App, set them
                commit('SET_CURRENT_TENANT_OBJECT', response === null || response === void 0 ? void 0 : response.available_tenants[0].org);
                localStorage.setItem('lastSelectedTenantId', String((_e = response === null || response === void 0 ? void 0 : response.available_tenants[0].org) === null || _e === void 0 ? void 0 : _e.id));
                commit('SET_CURRENT_APP_OBJECT', response.available_apps[0].app);
                localStorage.setItem('lastSelectedAppId', String((_f = response.available_apps[0].app) === null || _f === void 0 ? void 0 : _f.id));
            }
            else {
                const definitiveTenant = (_g = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _g === void 0 ? void 0 : _g.find((r) => {
                    var _a;
                    return ((_a = r.org) === null || _a === void 0 ? void 0 : _a.id) === lastSelectedTenantId ||
                        tenantsLen === 1 ||
                        r.apps.some(a => a.id === lastSelectedAppId || appsLen === 1);
                });
                const tenant = definitiveTenant || ((_h = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _h === void 0 ? void 0 : _h[0]);
                if (!tenant)
                    return;
                const org = tenant.org;
                const app = tenant.apps.find((a) => a.id === lastSelectedAppId) || tenant.apps[0];
                if (org) {
                    commit('SET_CURRENT_TENANT_OBJECT', tenant.org);
                    localStorage.setItem('lastSelectedTenantId', String(org.id));
                }
                if (app) {
                    commit('SET_CURRENT_APP_OBJECT', app);
                    localStorage.setItem('lastSelectedAppId', String(app.id));
                }
            }
            if (!state.currentAppObject)
                return false;
            const availableOrgs = yield rpc('orgs.orgs_fetch', { tenant_id: (_j = state.currentTenantObject) === null || _j === void 0 ? void 0 : _j.id, app_id: (_k = state.currentAppObject) === null || _k === void 0 ? void 0 : _k.id });
            if (!Array.isArray(availableOrgs))
                return false;
            commit('SET_AVAILABLE_ORGS', availableOrgs);
            let currentOrgObject;
            if (lastSelectedOrgId) {
                currentOrgObject = availableOrgs.find(org => org.id === lastSelectedOrgId);
            }
            // pick the first top-level
            if (!currentOrgObject) {
                const topLevelOrgs = availableOrgs.filter(o => !o.parent_id ||
                    !availableOrgs.some(p => p.id === o.parent_id));
                currentOrgObject = topLevelOrgs[0];
            }
            // failed to set complete context (Tenant-App-Org)
            if (!currentOrgObject)
                return false;
            dispatch('setCurrentOrgObject', currentOrgObject);
            return true;
        });
    },
    fetchAuthorizedAndActingUserData({ dispatch, commit }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const authorizedUserId = localStorage.getItem('authorized_user_id');
            const actingUserId = localStorage.getItem('authorized_user_id') || localStorage.getItem('acting_user_id');
            if (!authorizedUserId || !actingUser)
                dispatch('doLogout');
            // pre-setting user objects, so that we have at least IDs for other functions to work with
            commit('SET_USER_OBJ', { id: authorizedUserId, loaded: false });
            commit('actingUser/SET_USER_OBJ', { id: actingUserId, loaded: false }, { root: true });
            const response = yield fetchRecords('users.users', { payload: { filter_conditions: [{ field: 'id', predicate: 'equals', value: Number(authorizedUserId) }] } });
            if (response) {
                commit('SET_USER_OBJ', Object.assign(Object.assign({}, (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a[0]), { loaded: true }));
            }
            const response2 = yield fetchRecords('users.users', { payload: { filter_conditions: [{ field: 'id', predicate: 'equals', value: Number(actingUserId) }] } });
            if (response2) {
                commit('actingUser/SET_USER_OBJ', Object.assign(Object.assign({}, (_b = response2 === null || response2 === void 0 ? void 0 : response2.data) === null || _b === void 0 ? void 0 : _b[0]), { loaded: true }), { root: true });
            }
        });
    },
    setAuthorizedUser({ commit, dispatch }, params) {
        commit('SET_AUTHORIZED_USER', params);
    },
    submitCreds({ dispatch, state, rootState, commit }, { creds, ctx }) {
        return __awaiter(this, void 0, void 0, function* () {
            fullScreenLoading.show({ message: 'Logging in' });
            try {
                const response = yield ctx.$http.post(`https://api.sonar.cloud/user_token`, creds);
                if (response) {
                    // populate user objects with whatever data we got from user_token.  that data is later re-fetched using APIv1
                    commit('SET_USER_OBJ', response.body.token_user);
                    commit('actingUser/SET_USER_OBJ', response.body.token_user, { root: true });
                    dispatch('setAuthorizedUser', { userObj: Object.assign(Object.assign({}, response.body.token_user), { loaded: true }), jwt: response.body.jwt });
                    const postLoginUrl = localStorage.getItem('postLoginUrl');
                    if (postLoginUrl) {
                        if (postLoginUrl.endsWith('/login')) {
                            window.location.href = postLoginUrl.substring(0, postLoginUrl.length - 6);
                        }
                        else {
                            window.location.href = postLoginUrl;
                        }
                    }
                    else {
                        ctx.$router.push('/');
                    }
                }
            }
            catch (err) {
                if (err.status === 404) {
                    Notify.create({ message: 'Incorrect user name or password. Please note: An account will be locked after 3 consecutive failed login attempts.', color: 'negative' });
                    return;
                }
                if (err.body && err.body.error) {
                    Notify.create({ message: err.body.error, color: 'negative' });
                    return;
                }
                Notify.create({ message: 'Login error has occured. ', color: 'negative' });
            }
            finally {
                fullScreenLoading.hide();
            }
        });
    },
    updateOwnPassword({ dispatch, state }, { creds, ctx }) {
        return __awaiter(this, void 0, void 0, function* () {
            const userId = getActingUser().id;
            try {
                const response = yield ctx.$http.put(`https://api.sonar.cloud/users/${userId}/update_password`, creds);
                if (response)
                    Notify.create({ message: 'Password has been successfully updated', color: 'positive' });
                return true;
            }
            catch (err) {
                if (err.body && err.body.errors && err.body.errors.password) {
                    err.body.errors.password.forEach((r) => {
                        Notify.create({ message: `Password error: ${r}`, color: 'negative' });
                    });
                }
                return false;
            }
        });
    },
    doLogout({ commit }, params) {
        localStorage.setItem('postLoginUrl', window.location.href);
        commit('SET_AUTHORIZED_USER', { userIsSessionScoped: (params || {}).onlySessionScopedUser, userObj: null, jwt: null });
        if (!((params || {}).onlySessionScopedUser)) {
            localStorage.removeItem('user_data');
            localStorage.removeItem('AUTH_TOKEN');
        }
        sessionStorage.removeItem('user_data');
        sessionStorage.removeItem('AUTH_TOKEN');
        if (!params || !(params.doNotRedirectToLogin))
            window.location.href = '/login';
    },
    fetchAvailableTenantAppCombinations({ commit, dispatch }) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield rpc('users.available_tenant_app_combinations_for_user_fetch');
            if (!response)
                return false;
            commit('SET_AVAILABLE_TENANTS_AND_APPS', response);
            // now, we'll try to set tenant and app for the user, as default choice
            const appsLen = (_a = response.available_apps) === null || _a === void 0 ? void 0 : _a.length;
            const tenantsLen = (_b = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _b === void 0 ? void 0 : _b.length;
            const lastSelectedTenantId = Number(localStorage.getItem('lastSelectedTenantId'));
            const lastSelectedAppId = Number(localStorage.getItem('lastSelectedAppId'));
            if (lastSelectedAppId && lastSelectedTenantId) {
                const tenant = (_c = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _c === void 0 ? void 0 : _c.find((r) => r.org.id === lastSelectedTenantId);
                const app = tenant === null || tenant === void 0 ? void 0 : tenant.apps.find((a) => a.id === lastSelectedAppId);
                yield dispatch('setCurrentTenantObject', tenant === null || tenant === void 0 ? void 0 : tenant.org);
                dispatch('setCurrentAppObject', app);
                return;
            }
            if (appsLen === 1 && tenantsLen === 1) {
                dispatch('setCurrentAppObject', response.available_apps[0].app);
                dispatch('setCurrentTenantObject', response === null || response === void 0 ? void 0 : response.available_tenants[0].org);
            }
            else {
                const definitiveTenant = (_d = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _d === void 0 ? void 0 : _d.find((r) => {
                    var _a;
                    return ((_a = r.org) === null || _a === void 0 ? void 0 : _a.id) === lastSelectedTenantId ||
                        tenantsLen === 1 ||
                        r.apps.some(a => a.id === lastSelectedAppId || appsLen === 1);
                });
                const tenant = definitiveTenant || ((_e = response === null || response === void 0 ? void 0 : response.available_tenants) === null || _e === void 0 ? void 0 : _e[0]);
                if (!tenant)
                    return;
                const app = tenant.apps.find((a) => a.id === lastSelectedAppId) || ((_f = tenant.apps) === null || _f === void 0 ? void 0 : _f[0]);
                const org = tenant.org;
                if (org)
                    yield dispatch('setCurrentTenantObject', org);
                if (app)
                    yield dispatch('setCurrentAppObject', app);
            }
            if (response)
                return true;
        });
    },
    setCurrentTenantObject({ commit, dispatch, state }, val) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!val)
                return;
            commit('SET_CURRENT_APP_OBJECT', null); // need to have this line before setting tenant, otherwise "mark C" code can be triggered and may return error, because org/app combination may be not valid at this moment
            commit('SET_CURRENT_TENANT_OBJECT', val);
            localStorage.setItem('lastSelectedTenantId', String(val.id));
            yield dispatch('setCurrentOrgToBeTopLevelAvailableOrgUnderCurrentTenant');
            const apps = (_b = (_a = state.availableTenantsAndApps) === null || _a === void 0 ? void 0 : _a.available_tenants) === null || _b === void 0 ? void 0 : _b.find((r) => { var _a; return ((_a = r.org) === null || _a === void 0 ? void 0 : _a.id) === val.id; }).apps;
            if ((apps === null || apps === void 0 ? void 0 : apps.length) === 1) {
                dispatch('setCurrentAppObject', apps[0]);
            }
            else {
                commit('SET_CURRENT_APP_OBJECT', null);
            }
            return true;
        });
    },
    // mark A. Org mirror of mark B
    setCurrentOrgObjectById({ dispatch, state }, id) {
        dispatch('unsetRolesAndControlledActions');
        dispatch('setCurrentOrgObject', state.availableOrgs.find((r) => r.id === id));
    },
    setCurrentOrgObject({ commit, dispatch }, val) {
        dispatch('unsetRolesAndControlledActions');
        commit('SET_CURRENT_ORG_OBJECT', val);
        localStorage.setItem('lastSelectedOrgId', String(val === null || val === void 0 ? void 0 : val.id));
        if (state.currentAppObject)
            dispatch('fetchAuthorizedUserPermissionsForCurrentAppOrg'); // mark C
    },
    // mark B. App mirror of mark A
    setCurrentAppObjectById({ dispatch, state }, id) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            dispatch('unsetRolesAndControlledActions');
            if (!state.availableTenantsAndApps) {
                yield dispatch('fetchAvailableTenantAppCombinations');
            }
            const app = (_b = (_a = state.availableTenantsAndApps) === null || _a === void 0 ? void 0 : _a.available_apps) === null || _b === void 0 ? void 0 : _b.find((r) => { var _a; return ((_a = r.app) === null || _a === void 0 ? void 0 : _a.id) === id; }).app;
            dispatch('setCurrentAppObject', app);
        });
    },
    setCurrentAppObject({ commit, dispatch }, val) {
        dispatch('unsetRolesAndControlledActions');
        commit('SET_CURRENT_APP_OBJECT', val);
        localStorage.setItem('lastSelectedAppId', String(val === null || val === void 0 ? void 0 : val.id));
        if (state.currentOrgObject)
            dispatch('fetchAuthorizedUserPermissionsForCurrentAppOrg');
    },
    setCurrentOrgToBeTopLevelAvailableOrgUnderCurrentTenant({ dispatch, state, commit }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!state.currentTenantObject)
                debugger;
            const availableOrgs = (yield rpc('orgs.orgs_fetch', { tenant_id: (_a = state.currentTenantObject) === null || _a === void 0 ? void 0 : _a.id, app_id: ((_b = state.currentAppObject) === null || _b === void 0 ? void 0 : _b.id) || -1 })) || [];
            commit('SET_AVAILABLE_ORGS', availableOrgs);
            const lastSelectedOrgId = Number(localStorage.getItem('lastSelectedOrgId'));
            if (lastSelectedOrgId && (availableOrgs || []).some((org) => (org === null || org === void 0 ? void 0 : org.id) === lastSelectedOrgId)) {
                dispatch('setCurrentOrgObject', availableOrgs.find((org) => (org === null || org === void 0 ? void 0 : org.id) === lastSelectedOrgId));
            }
            else {
                const topLevelOrgs = availableOrgs.filter((org1) => !org1.parent_id || !availableOrgs.find((org2) => (org2 === null || org2 === void 0 ? void 0 : org2.id) === org1.parent_id));
                dispatch('setCurrentOrgObject', topLevelOrgs[0]);
            }
            if (availableOrgs)
                return true;
        });
    },
    fetchAuthorizedUserPermissionsForCurrentAppOrg({ commit, dispatch }) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const authorizedUserId = JSON.parse(localStorage.getItem('authorized_user_id') || '');
            if (!authorizedUserId) {
                window.location.href = '/login';
                return false;
            }
            if (!state.currentOrgObject) {
                setTimeout(this.fetchAuthorizedUserPermissionsForCurrentAppOrg, 1000);
                return;
            }
            const orgIdParam = ((_a = state.currentOrgObject) === null || _a === void 0 ? void 0 : _a.id) || null;
            const appIdParam = ((_b = state.currentAppObject) === null || _b === void 0 ? void 0 : _b.id) || null;
            const response = yield rpc('controlled_actions.org_app_specific_roles_and_permissions_for_user_fetch', { user_id: authorizedUserId, org_id: orgIdParam, app_id: appIdParam });
            if (response) {
                if ((response.roles || []).length < 1 || (response.controlled_actions || []).length < 1) {
                    debugger;
                    console.error(`The authorized user does not have appropriate permissions for using the requested app in the requested organization`);
                    Notify.create({ message: `The authorized user does not have appropriate permissions for using the requested app in the requested organization`, color: 'negative' });
                    dispatch('mode/setCurrentMode', { component: Account }, { root: true });
                }
                commit('SET_ROLES', response.roles);
                commit('SET_CONTROLLED_ACTIONS', response.controlled_actions);
                dispatch('actingUser/setRoles', response.roles, { root: true });
                dispatch('actingUser/setControlledActions', response.controlled_actions, { root: true });
                return true;
            }
        });
    }
};
const namespaced = true;
export default { state, actions, mutations, namespaced, getters };
